// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"37a2c04e","989":"440a02cd"}[chunkId] + ".chunk.js";
};